export default __webpack_public_path__ + "static/media/facility1.e42d854c.jpg";